import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isAxiosError } from "axios";
import { toast } from "sonner";
import { useAuthStore } from "../../stores/auth";
import { useLogin } from "./queries";
import { loginSchema } from "@endeks/shared";
import { safeNextPath } from "@/lib/safe-redirect";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Oturum düşünce gelinen sayfa (?next=); yalnızca aynı origin'deki göreli yol
  const nextPath = safeNextPath(searchParams.get("next"));
  const setAuth = useAuthStore((s) => s.setAuth);
  const loginMutation = useLogin();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const values = { email, password };
    const result = loginSchema.safeParse(values);
    if (!result.success) {
      const errors = result.error.issues.map((i) => i.message).join(", ");
      toast.error(errors);
      return;
    }

    try {
      const data = await loginMutation.mutateAsync(values);
      setAuth(data.access_token, data.refresh_token, data.user);
      toast.success("Giriş başarılı!");
      navigate(nextPath, { replace: true });
    } catch (error: unknown) {
      toast.error(
        isAxiosError(error)
          ? (error.response?.data?.message ?? "Giriş başarısız")
          : "Giriş başarısız",
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] to-[#1e3a5f]">
      <Card className="w-full max-w-sm shadow-2xl border-0">
        <CardHeader className="text-center pb-2">
          <div className="mb-2">
            <span className="text-3xl font-bold tracking-wider text-[#1e3a5f]">ENDEKS</span>
            <span className="block w-8 h-1 bg-red-600 mx-auto mt-1 rounded" />
          </div>
          <CardTitle className="text-lg font-semibold text-foreground">Admin Panel</CardTitle>
          <CardDescription>Hesabınıza giriş yapın</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                type="email"
                placeholder="ornek@endeks.com"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-[#1e3a5f] hover:bg-[#163058]"
              disabled={loginMutation.isPending}
            >
              {loginMutation.isPending ? "Giriş yapılıyor…" : "Giriş Yap"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
